export var UserActivityEvent = /*#__PURE__*/function (UserActivityEvent) {
  UserActivityEvent["PAGE_VIEW"] = "page_view";
  UserActivityEvent["PURCHASE"] = "purchase";
  UserActivityEvent["SHOPPING_CART"] = "shopping_cart";
  UserActivityEvent["CLICK"] = "click";
  UserActivityEvent["PLAY_TRAILER"] = "trailer";
  UserActivityEvent["COMMENT_COURSE"] = "comment";
  UserActivityEvent["CREATE_COURSE_REVIEW"] = "review";
  UserActivityEvent["CREATE_PROJECT"] = "upload_project";
  UserActivityEvent["ENROLLMENT"] = "enrollment";
  UserActivityEvent["RECOMMENDATION_VIEW"] = "recommendation_view";
  UserActivityEvent["RECOMMENDATION_POSITION_CLICK"] = "recommendation_position_click";
  UserActivityEvent["RECOMMENDATION_POSITION_CHECKOUT"] = "recommendation_position_checkout";
  UserActivityEvent["DOWNLOAD_RESOURCE"] = "download";
  UserActivityEvent["READ_ARTICLE"] = "read_article";
  UserActivityEvent["CHECKOUT"] = "checkout";
  UserActivityEvent["SEARCH_CLICK"] = "search_click";
  UserActivityEvent["SEND_FORM"] = "send_form";
  UserActivityEvent["PRODUCT_PRICING_VIEW"] = "product_pricing_view";
  UserActivityEvent["FIRST_PLAY"] = "play";
  return UserActivityEvent;
}({});